import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiX } from 'react-icons/fi';

import { navigationSections } from '../../routesConfig';
import './Sidebar.css';

function Sidebar({ isOpen, toggleSidebar }) {
  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar__brand-row">
        <div>
          <span className="sidebar__eyebrow">Accounting</span>
          <strong className="sidebar__brand">Finance Desk</strong>
        </div>
        <button className="sidebar__close" onClick={toggleSidebar} aria-label="Close navigation">
          <FiX />
        </button>
      </div>

      <div className="sidebar__intro">
        Navigate by workflow — sections group related tasks for quicker access.
      </div>

      <nav className="sidebar__nav" aria-label="Primary navigation">
        {navigationSections.map((section) => (
          <section key={section.label} className="sidebar__section">
            <h2>{section.label}</h2>
            <div className="sidebar__links">
              {section.routes.map((route) => {
                const Icon = route.icon;
                return (
                  <NavLink
                    key={route.path}
                    to={route.path}
                    className={({ isActive }) => `sidebar__link${isActive ? ' sidebar__link--active' : ''}`}
                  >
                    <span className="sidebar__link-icon"><Icon /></span>
                    <span>
                      <strong>{route.label}</strong>
                      <small>{route.description}</small>
                    </span>
                  </NavLink>
                );
              })}
            </div>
          </section>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
